"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.containsEmoji = void 0;
function containsEmoji(text) {
    const regex_emoji = /[\p{Extended_Pictographic}\u{1F3FB}-\u{1F3FF}\u{1F9B0}-\u{1F9B3}]/u;
    return regex_emoji.test(text);
}
exports.containsEmoji = containsEmoji;
